module.exports = __webpack_public_path__ + "img/thank-you.41096e6b.svg";